// ===================================================================
// The Crowd v2 — Projets : aides partagees
//
// Formats, libelles et regles d'affichage communs a la fiche projet et,
// plus tard, a Mes projets, Mes etapes et la vue manager. Aucune regle
// de droits ici : les droits viennent du backend (mes_droits).
// ===================================================================

export const STATUTS_PROJET = ["En cours", "En attente", "Termine", "Abandonne"];

// Valeurs en base sans accent (contrainte CHECK) ; libelles affiches
export const LIBELLES_STATUT = {
  "En cours": "En cours",
  "En attente": "En attente",
  Termine: "Terminé",
  Abandonne: "Abandonné",
};

export const LIBELLES_STATUT_JALON = {
  en_cours: "En cours",
  propose: "Proposé",
  atteint: "Atteint",
};

export const LIBELLES_ROLE_PROJET = {
  chef: "Chef de projet",
  cochef: "Co-chef",
  principal: "Acteur principal",
  secondaire: "Acteur secondaire",
};

// Date ISO (AAAA-MM-JJ ou datetime) -> AAAA-MM-JJ, pour les champs date
export function dateCourte(valeur) {
  if (!valeur) return "";
  return String(valeur).split("T")[0];
}

// 12 oct. 2026
export function formatDate(valeur) {
  const d = dateCourte(valeur);
  if (!d) return "—";
  return new Date(`${d}T00:00:00Z`).toLocaleDateString("fr-FR", {
    day: "numeric", month: "short", year: "numeric", timeZone: "UTC",
  });
}

// Horizon d'un jalon, presente comme une periode : « novembre 2026 »
export function formatHorizon(valeur) {
  const d = dateCourte(valeur);
  if (!d) return null;
  return new Date(`${d}T00:00:00Z`).toLocaleDateString("fr-FR", {
    month: "long", year: "numeric", timeZone: "UTC",
  });
}

export function formatHeures(h) {
  const n = Number(h) || 0;
  return `${Number.isInteger(n) ? n : n.toFixed(2).replace(/\.?0+$/, "")} h`;
}

export function formatTaille(octets) {
  if (!octets && octets !== 0) return "—";
  if (octets < 1024) return `${octets} o`;
  if (octets < 1024 * 1024) return `${Math.round(octets / 1024)} Ko`;
  return `${(octets / (1024 * 1024)).toFixed(1)} Mo`;
}

function aujourdhui() {
  return new Date().toISOString().split("T")[0];
}

// Rappel de retard : projet en cours dont la date de fin prevue est depassee
export function projetEnRetard(projet) {
  const fin = dateCourte(projet?.date_fin_prevue);
  return Boolean(fin) && projet.statut === "En cours" && fin < aujourdhui();
}

// Rappel de retard : etape non terminee dont la date de fin prevue est depassee
export function etapeEnRetard(etape) {
  const fin = dateCourte(etape?.date_fin_prevue);
  return Boolean(fin) && (etape.avancement || 0) < 100 && fin < aujourdhui();
}

// Tonalite d'un badge de statut de projet (classes de v2-composants.css)
export function classeStatutProjet(statut) {
  if (statut === "Termine") return "v2-statut v2-statut-success";
  if (statut === "Abandonne") return "v2-statut";
  if (statut === "En attente") return "v2-statut v2-statut-warning";
  return "v2-statut v2-statut-fort";
}

export function classeStatutJalon(statut) {
  if (statut === "atteint") return "v2-statut v2-statut-success";
  if (statut === "propose") return "v2-statut v2-statut-warning";
  return "v2-statut";
}

// Largeur d'une jauge, bornee a 0-100 %
export function largeurJauge(valeur, maximum = 100) {
  if (!maximum) return "0%";
  return `${Math.max(0, Math.min(100, (Number(valeur) / Number(maximum)) * 100))}%`;
}

// Nom affichable d'un collaborateur de /api/collaborateurs
export function nomCollaborateur(c) {
  return c ? `${c.prenom} ${c.nom}` : "";
}
